// assistant.ts — Assistant d'aide fonctionnelle.
// PMO-app vérifie l'auth + le consentement IA et émet un jeton court ; le
// CONTENU des questions part ensuite DIRECTEMENT au Worker air-gapped, jamais
// via PMO-app (minimisation des données).
import { req } from './_internals.js';

export interface AssistantConfig {
  enabled: boolean;
  worker_url: string | null;
  consented: boolean;
  version: string;
}

export interface AssistantToken {
  token: string;
  worker_url: string;
  version: string;
  ttl: number;
}

export const assistantApi = {
  getAssistantConfig: () => req<AssistantConfig>('GET', '/assistant/config'),
  issueAssistantToken: () => req<AssistantToken>('POST', '/assistant/token'),
};
